"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorResponseException = void 0;
const api_1 = require("./api");
// Generic API exception, based on FLASKs error_response
class ErrorResponseException extends Error {
    constructor(messageText, status, httpCode, appCode, statusText, errors) {
        super(`Api request failed: ${messageText}`);
        this.messageText = messageText;
        this.status = status;
        this.httpCode = httpCode;
        this.appCode = appCode;
        this.statusText = statusText;
        this.errors = errors;
    }
}
exports.ErrorResponseException = ErrorResponseException;
class JsonApi {
    constructor(api) {
        this.api = api;
    }
    async get(endpoint, queryParams) {
        return this.request(api_1.Method.GET, endpoint, queryParams, undefined);
    }
    async post(endpoint, content, queryParams) {
        return this.request(api_1.Method.POST, endpoint, queryParams, content);
    }
    async put(endpoint, content, queryParams) {
        return this.request(api_1.Method.PUT, endpoint, queryParams, content);
    }
    async patch(endpoint, content, queryParams) {
        return this.request(api_1.Method.PATCH, endpoint, queryParams, content);
    }
    async delete(endpoint, queryParams) {
        return this.request(api_1.Method.DELETE, endpoint, queryParams, undefined);
    }
    async request(method, endpoint, queryParams, content) {
        var _a;
        try {
            const response = await this.api.request(method, endpoint, queryParams, Object.assign({ Accept: "application/json" }, (content ? { "Content-Type": "application/json" } : {})), content ? JSON.stringify(content) : undefined);
            const json = await response.json();
            return json.data;
        }
        catch (e) {
            if (e instanceof Response) {
                const isJson = (_a = e.headers.get("Content-Type")) === null || _a === void 0 ? void 0 : _a.includes("application/json");
                if (isJson) {
                    const { message, status, httpCode, appCode, errors } = await e.json();
                    throw new ErrorResponseException(message, status, httpCode, appCode, e.statusText, errors);
                }
                const message = await e.text();
                throw new ErrorResponseException(message, "error", e.status, "UNKNOWN_ERROR", e.statusText);
            }
            throw e;
        }
    }
}
exports.default = JsonApi;
//# sourceMappingURL=json-api.js.map